import React, {createRef, useState} from 'react';
import __ from "lodash";
import moment from "moment";
import {Grid} from "@material-ui/core";

import {MaskedText, DatePicker, FormDialog, ComboSelect} from "../../../../controls";
import FuelOrderLineEditor from "./FuelOrderLineEditor";
import AirportLookup from "../../../Airports/components/AirportsLookup";
import AirportNameTooltip from "../../../Airports/components/AirportNameTooltip";
import DocumentTemplateLookup from "../../../Settings/components/DocumentTemplateLookup";
import FuelSuppliersAtAirport from "../../../Companies/components/FuelSuppliersAtAirport";
import Validator from "../../validators/FuelOrdersValidator";
import AirportFuelSupplierLookup from "../../../Companies/components/AirportFuelSupplierLookup";
import MultiFlightSelectDialog from "./MultiFlightSelectDialog";


const AddFuelOrderDialog = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }

  const SystemData = props.SystemData;
  const extraKeys = props.extraKeys;
  const handleAdd = props.handleAdd
  const formatChars = props.formatChars;
  const classes = props.classes;
  const preSelection = props.preSelection || false;

  const requestRef = createRef(0);
  const eventBus = SystemData.eventBus;

  const [dialogStates, setDialogStates] = useState(props.dialogStates);

  const dateFormat = "DD/MM/YYYY";

  const handleAddLine = () => {
    if (eventBus) {
      eventBus.trigger('FuelOrder.AddLine');
    }
  }

  const handleAddMultipleLines = () => {
    if (eventBus) {
      const params = { title: "Select Flights to add to Order", canEdit: true }
      eventBus.trigger('FlightListLookup.open', params);
    }
  }
  const setFuelPolicy = (lines) => {
    let fuelPolicy = "";
    if (lines && Array.isArray(lines)) {
      lines.forEach(line => {
        if (fuelPolicy === "")
          fuelPolicy = line.fuelPolicy;
        if (fuelPolicy !== line.fuelPolicy)
          fuelPolicy = "VARIOUS";
      })
    }
    return fuelPolicy;
  }

  const handleLinesChanged = (changes, props) => {
    const {record, recordChange} = props;
    if (changes && changes.record) {
      const lines = changes.record.lines;
      record['lines'] = lines;
      record['periodFrom'] = changes.record.periodFrom;
      record['periodTo'] = changes.record.periodTo;
      record['fuelPolicy'] = setFuelPolicy(lines);
      recordChange({...record, lines: lines, periodFrom: changes.record.periodFrom, periodTo: changes.record.periodTo});

      if (changes.resolve) {
        changes.resolve();
      }
    }
  }

  if (dialogStates.showDialog) {
    return (
      <FormDialog
        title={dialogStates.title}
        message=""
        open={dialogStates.showDialog}
        record={dialogStates.record}
        dialogOptions={{maxWidth: "lg", fullWidth: true}}
        classes={classes}
        validator={Validator}
        buttons = {{
          addLine: {icon: "add_circle", key: "Add Line", label: "Add Line", color: "primary", disabled: (status)=>{return status.error && status.errorMessage !== "At least one order line is required"}},
          addMultiLine: {icon: "add_circle", key: "Add Multiple Flights", label: "Add Multiple Flights", color: "primary", disabled: (status)=>{return status.error && status.errorMessage !== "At least one order line is required"}},
          save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{
            if (status.buttonState && status.buttonState.disabled) return true;
            return status.error}},
          send:{icon: "send", key: "Send", label: "Save & Send", color: "primary", disabled: (status)=>{
            if (status.buttonState && status.buttonState.disabled) return true;
            return status.error}},
          cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save" || state.buttonPressed === "send") {
            const record = state.record;
            handleAdd.mutate({
              extraKeys,
              record,
              postSuccess: () => {
                setDialogStates({...dialogStates, showDialog: false, record: null});
                if (state.buttonPressed === "send" && props.onChange) {
                  props.onChange(record);
                } else if (props.close)
                  props.close();
              },
              postError: (data) => {
                if (data.errorMessage) {
                  SystemData.alert("Error", `${data.errorMessage}`);
                } else {
                  SystemData.alert("Error", `An Unexpected Error has occurred.`);
                }
              }
            });
          } else if (state.buttonPressed === "addLine") {
            handleAddLine();
          } else if(state.buttonPressed === "addMultiLine")  {
            handleAddMultipleLines();
          } else {
            setDialogStates({...dialogStates, showDialog: false, record: null});
            if (props.close)
              props.close();
          }
        }}

      >
        <Grid container checkChildren={true} spacing={3}>
          <Grid item xs={2} checkChildren={true}>
            <DatePicker
              id="orderDate"
              label="Order Date"
              style={{width: "100%"}}
              disableToolbar={true}
              autoOk={true}
              format={dateFormat}
            />
          </Grid>
          <Grid item xs={2} checkchildren="true">
            {record =>
              <div>
                <AirportLookup
                  id="airportCode"
                  label="At Airport"
                  inputLabelProps={{shrink: true}}
                  style={{width: "100%"}}
                  returnType={"object"}
                  //readOnly={editing!==true}
                  onChange={(returnObject, props) => {
                    if (returnObject && returnObject.found) {
                      const data = {
                        ...props.record,
                        airportCode: returnObject.data.airportCode,
                        airportName: returnObject.data.airportName,
                      }
                      if (returnObject.value.toUpperCase() !== props.record.airportCode.toUpperCase()) {
                        data["fuelSupplierUuid"] = null;
                        data["companyName"] = null;
                        data["supplyDetails"] = null;
                      }
                      props.recordChange(data);
                      const titleParts = dialogStates.title.split(" // ");
                      if (titleParts.length > 1)
                        titleParts[1] = returnObject.value.toUpperCase();
                      else if (titleParts.length === 1)
                        titleParts.push(returnObject.value.toUpperCase());
                      setDialogStates({...dialogStates, title: `${titleParts.join(" // ")}`});
                    } else {
                      props.onChange(returnObject.value);
                    }
                  }}
                />
                {record.airportCode
                  ?
                    <div>
                      <AirportNameTooltip
                        airportCode={record.airportCode}
                        onChange={(airport, props) => {
                          if (!__.isEmpty(airport) && airport.airportName !== props.record.airportName) {
                            const data = {
                              ...props.record,
                              airportName: airport.airportName,
                            }
                            props.recordChange(data);
                          }
                        }}
                      />
                      <FuelSuppliersAtAirport
                        airportCode={record.airportCode}
                        onChange={(fuelSupplier, props) => {
                          if (fuelSupplier.defaultSupplier && fuelSupplier.companyName !== props.record.companyName && fuelSupplier.airportCode !== props.record.airportCode) {
                            const data = {
                              ...props.record,
                              fuelSupplierUuid: fuelSupplier.companyUuid,
                              companyName: fuelSupplier.companyName,
                              supplyDetails: `${fuelSupplier.companyName} (${__.capitalize(fuelSupplier.contractType)}, ${fuelSupplier.pricePeriod})`
                            }
                            props.recordChange(data);
                          }
                        }}
                      />
                    </div>
                  :
                    <></>
                }
              </div>
            }
          </Grid>
          <Grid item xs={4} checkchildren="true">
            <MaskedText
              id="airportName"
              label="Airport Name"
              inputLabelProps={{ shrink: true }}
              style={{width: "100%"}}
              mask={"x".repeat(80)}
              maskChar={""}
              alwaysShowMask={false}
              formatChars={formatChars}
              forceUpperCase={true}
              readOnly={true}
            />
          </Grid>
          <Grid item xs={4} checkchildren="true">
            {(record, changeRecord) => (
              <AirportFuelSupplierLookup
                id="fuelSupplierUuid"
                label="Fuel Supplier"
                shrink
                returnType="object"
                value={props.value}
                airportCode={record.airportCode}
                onChange={(returnObject, props) => {
                  if (returnObject.found) {
                    const fuelSupplier = returnObject.data;
                    if (!__.isEmpty(fuelSupplier) && fuelSupplier.companyName !== props.record.companyName) {
                      const data = {
                        ...props.record,
                        fuelSupplierUuid: fuelSupplier.companyUuid,
                        companyName: fuelSupplier.companyName,
                        supplyDetails: `${fuelSupplier.companyName} (${__.capitalize(fuelSupplier.contractType)}, ${fuelSupplier.pricePeriod})`
                      }
                      props.recordChange(data);
                    }
                  } else {
                    props.onChange(returnObject.value);
                  }
                }}
              />
            )}
          </Grid>
          <Grid item xs={4} checkchildren="true">
            <MaskedText
              id="supplyDetails"
              label="Supply Details"
              inputLabelProps={{ shrink: true }}
              style={{width: "100%"}}
              mask={"x".repeat(80)}
              maskChar={""}
              alwaysShowMask={false}
              formatChars={formatChars}
              forceUpperCase={true}
            />
          </Grid>
          <Grid item xs={4} checkchildren="true">
            <DocumentTemplateLookup
              id="fuelOrderTemplateUuid"
              label="Order Template"
              inputProps={{readOnly:false}}
              readOnly={false}
              shrink="true"
              documentType="FUEL_ORDER"
            />
          </Grid>
          <Grid item xs={4} checkchildren="true">
            <DocumentTemplateLookup
              id="attachmentUuid"
              label="Attachment"
              inputProps={{readOnly:false}}
              readOnly={false}
              shrink="true"
              documentType="OTHER"
            />
          </Grid>
          {/*<Grid item xs={4} checkChildren={true}>*/}
          {/*  <ComboSelect*/}
          {/*    id="fuelPolicy"*/}
          {/*    label="Fuel Policy"*/}
          {/*    group="FUEL POLICY TYPE"*/}
          {/*    subGroup=""*/}
          {/*    readOnly={false}*/}
          {/*    style={{marginTop: "3px"}}*/}
          {/*    fullWidth*/}
          {/*  />*/}
          {/*</Grid>*/}
          <Grid item xs={12} checkChildren={true}>
            {(record, changeRecord, changeButtonState)=>
              <FuelOrderLineEditor
                orderRecord={record}
                handleUpdate={handleAdd}
                extraKeys={extraKeys}
                canEdit={true}
                classes={classes}
                onChange={handleLinesChanged}
                changeButtonState={changeButtonState}
              />
            }
          </Grid>
        </Grid>
        {(record, changeRecord, changeButtonState)=>
          <MultiFlightSelectDialog
            classes={classes}
            systemData={SystemData}
            formatChars={formatChars}
            airportCode={record.airportCode}
            fromDate={moment.utc().format("YYYY-MM-DD")}
            lines={record.lines}
            onChange={(orderLines)=>{
              const lines = [...record.lines];
              let fuelPolicy = record.fuelPolicy;
              if (orderLines && Array.isArray(orderLines)) {
                orderLines.forEach(line => {
                  if (__.find(lines, {tripLegUuid: line.tripLegUuid}) === undefined)
                    lines.push(line);
                  if (!fuelPolicy)
                    fuelPolicy = line.fuelPolicy;
                  if (fuelPolicy !== line.fuelPolicy)
                    fuelPolicy = "VARIOUS";
                });
              }
              changeRecord({lines: lines, fuelPolicy });
            }}
          />
        }
      </FormDialog>
    )
  }
  return (<></>);
}

export default AddFuelOrderDialog;
